import React from "react";
import {Helmet} from "react-helmet";

export const Team = (props) => {
  return (
    <>
    <Helmet>
      <title>MGM Saúde e Estética Avançada</title>
      <meta name="description" content="Clínica de Estética em Copacabana, Rio de Janeiro especializada em correção das orelhas de abano, bioestimuladores, drenagem linfática, enzimas contra celulite e gordura localizada, fios de PDO, harmonização de glúteos, massagem modeladora, microagulhamento, preenchimento labial, subcisão, terapia capilar e toxina botulínica, Destaca-se pelo atendimento onde cada paciente recebe um protocolo de tratamento individualizado." />
    </Helmet>
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <p>{" "}</p>
          <p>CONHEÇA NOSSA</p>
          <h2>Equipe</h2>
          <p>
            Nossa equipe é qualificada, com profissionais especializados em diversas áreas, comprometidos em oferecer tratamentos modernos e eficazes.
          </p>
        </div>
        <div id="row" >
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4 col-sm-6 team">
                  <div className="thumbnail">
                    {" "}
                    <img src={d.img} alt="..." className="team-img" />
                    <div className="caption">
                      <h4>{d.name}</h4>
                      <p>{d.job}</p>
                      {d.instagram && <p><a href={d.instagram} target="_blank" rel="noreferrer">Instagram  <i className="fa fa-instagram"></i></a></p> }
                      {d.www && <p><a href={d.www} target="_blank" rel="noreferrer">Web  <i className="fa fa-external-link"></i></a></p> }
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
        <div className="col-md-8 col-md-offset-2 portfolio-btn">
          <a href="https://api.whatsapp.com/send?phone=5521980366885&text=Ol%C3%A1,%20vi%20a%20p%C3%A1gina%20da%20cl%C3%ADnica%20e%20gostaria%20de%20agendar%20uma%20consulta." className="btn btn-custom btn-lg " target="_blank" rel="noreferrer">
          Agendar Consulta <i className="fa fa-whatsapp"></i>
          </a>{" "}
        </div> 
      </div>
    </div>
    </>
  );
};
